import * as constants from '../constants/actions';

const initialState = {
  pageTitle: 'Crash of Rhinos',
  pageBack: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constants.HEADER_TITLE:
      return headerTitle(state, action);
    case constants.HEADER_BACK:
      return headerBack(state, action);
    default:
      return state;
  }
}

function headerTitle(state, action) {
  return Object.assign({}, state, {
    pageTitle: action.title
  });
}

function headerBack(state, action) {
  return Object.assign({}, state, {
    pageBack: action.status
  });
}


// WEBPACK FOOTER //
// ./src/reducers/header.jsx